<template>
  <div>
    <div class="menu__footer col col-12">
      <div class="menu-container">
        <span>
          <a
            :href="$t('diagnostics-link')"
            class="text-h3"
          >{{ $t("Genetic Diagnostics") }}</a>
        </span>

        <span>
          <a
            :href="$t('research-pharma-solutions-link')"
            class="text-red text-h3"
          >{{ $t("Research & Pharma Solutions") }}</a>
        </span>
        <span class="about-us-headline">
          <a
            :href="$t('about-us-link')"
            class="text-h3"
          >{{ $t("About Us") }}</a>
        </span>
      </div>
      <div class="separator" />

      <div class="menu-links">
        <span>
          <a :href="$t('genetic-cosultation-link')">
            {{ $t("Genetic Consultation") }}</a><br>
          <a :href="$t('prevention-link')">{{ $t("Prevention") }}</a><br>
          <a :href="$t('family-planning-link')">
            {{ $t("Family Planning") }}</a><br>
          <a :href="$t('prenatal-diagnostics-link')">
            {{ $t("Prenatal Diagnostics") }}</a><br>
          <a :href="$t('rare-diseases-link')">
            {{ $t('Rare Diseases') }}</a><br>
          <a :href="$t('tumor-diseases-link')">
            {{ $t('Tumor Diseases') }}</a><br>
          <a :href="$t('single-gene-and-segregation-link')">
            {{ $t('Single Gene and Segregationsanalysis') }}</a><br>
          <a :href="$t('diagnostic-methods-link')">
            {{ $t('Diagnostic Methods') }}</a><br>
          <a :href="$t('general-information-link')">
            {{ $t('General Information') }}</a>
        </span>

        <span>
          <a
            :href="$t('sequencing-services-link')"
          >{{ $t('Sequencing Services') }}</a><br>
          <a
            :href="$t('Epigenomics')"
          >{{ $t('Epigenomics') }}</a><br>
          <a
            :href="$t('microbiome-analysis-link')"
          >{{ $t('Microbiome Analysis') }}</a><br>
          <a
            :href="$t('translational-oncology-link')"
          >{{ $t('Translational Oncology') }}</a><br>
          <a
            :href="$t('immunology-link')"
          >{{ $t('Immunology') }}</a><br>
          <a
            :href="$t('pharma-solutions-link')"
          >{{ $t('Pharma Solutions') }}</a><br>
          <a
            :href="$t('knowledge-center-link')"
          >{{ $t('Knowledge Center') }}</a>
        </span>

        <span class="about-us-links">
          <a :href="$t('news-publications-link')">{{ $t('News & Publications') }}</a><br>
          <a :href="$t('presse-area-link')">{{ $t('Presse Area') }}</a><br>
          <a :href="$t('events-link')">{{ $t('Events') }}</a><br>
          <a :href="$t('careers-link')">{{ $t('Careers') }}</a><br>
          <a :href="$t('contact-link')">{{ $t('Contact') }}</a>
        </span>
      </div>
    </div>
    <div class="grey__footer col col-12">
      <div class="side-section">
        <p>© Copyright – CeGaT GmbH</p>
      </div>
      <div
        class="middle-section"
        style="text-align: center"
      >
        <p v-html="$t('footer-text')" />
      </div>
      <div class="side-section">
        <p style="text-align: right">
          <a :href="$t('terms-conditions-link')">{{ $t('Terms & Conditions') }}&nbsp;</a>
          |&nbsp;
          <a :href="$t('privacy-policy-link')"> {{ $t('Privacy Policy') }}&nbsp;</a>
          |&nbsp;
          <a :href="$t('imprint-link')">{{ $t('Imprint') }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.menu__footer {
  padding: 24px;

  .menu-container {
    display: flex;
    margin-top: 10rem;
    margin-bottom: 0.75rem;
    padding-left: 1.0rem;
    align-items: flex-end;
  }

  .about-us-headline,
  .about-us-links {
    margin-left: 5rem;
    max-width: 15rem;
  }

  span {
    flex: 1;
  }

  a {
    font-size: 1.5rem;
    color: rgb(var(--v-theme-blue));
    font-weight: 400;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-timing-function: linear;
  }

  .red {
    color: rgb(var(--v-theme-footer-red));
  }

  .separator {
    height: 1px;
    background-color: rgb(var(--v-theme-grey-stroke));
  }

  .menu-links {
    display: flex;
    margin: 1.25rem 0;
    padding-left: 1.0rem;
    a {
      color: rgba(var(--v-theme-link-black), var(--v-main-opacity));
      font-size: 1.125rem;
      line-height: 2rem;

      &:hover {
        color: rgb(var(--v-theme-black));
        text-decoration: underline;
      }
    }
  }

  @media #{map.get($display-breakpoints, 'sm-and-down')} {
    .menu-container {
      flex-direction: column;
      align-items: flex-start;
      gap: 3.125rem;
    }
    .menu-links {
      display: none;
    }
    .about-us-headline,
    .about-us-links {
      margin-left: 0;
      max-width: 100%;
    }
    .seperator {
      display: none;
    }
  }
}

.grey__footer {
  background-color: rgba(var(--v-theme-link-black), var(--v-main-opacity));
  color: rgb(var(--v-theme-white));
  font-size: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.875rem 12px 12px;
  flex-wrap: wrap;
  line-height: initial;

  .side-section {
    flex: 1;
  }

  .middle-section {
    flex: 2;
    text-align: center;
  }

  p {
    margin: 0.625rem 0;
  }

  a {
    color: rgb(var(--v-theme-white));
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @media #{map.get($display-breakpoints, 'sm-and-down')} {
    .middle-section {
      flex-basis: 100%;
    }
    .side-section {
      order: 1;
    }
  }
}
</style>
